<template>
    <div class="type-verification donotprint">
        <a class="help-icon float-left -ml-6" href="#verification">
            <i aria-hidden="true" class="material-icons">help</i>
        </a>

        <div class="inline-block relative">
            <ul>
                <li v-for="tab in type_scores"
                    class="match"
                    :class="{ 'active': tab.name == active }"
                >
                    <a class="flex flex-col" :href="'?result=' + tab.id + currentHash">
                        <div class="flex flex-row -mx-3 -mt-1 h-2 mb-1 border-green-600 border-b"
                            :class="tab.name == active ? 'border-green-600' : 'border-green-900'"
                        >
                            <div class="w-2/3" :style="'background-color: ' + tab.dominant_color"></div>
                            <div class="w-1/3" :style="'background-color: ' + tab.auxiliary_color"></div>
                        </div>
                        {{ tab.name_hidden }}
                    </a>
                </li>
            </ul>
        </div>
        <a href="#confirmation" class="block leading-loose text-center uppercase text-xxs text-white"> Ready To Confirm? </a>
    </div>
</template>

<script>
export default {
    props: {
        type_scores: {},
        active: {},
    },

    data() {
        return {
            currentHash: '',
        }
    },

    created() {
        this.$root.$on('reportNavChanged', (currentItem) => {
            if (currentItem && currentItem.hash.charAt(0) === '#') {
                this.currentHash = currentItem.hash;
            }
        });
    },
};
</script>
